"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var base_1 = require("./base");
var ToolsClient = /** @class */ (function (_super) {
    __extends(ToolsClient, _super);
    function ToolsClient(debug, toolsConfig) {
        if (debug === void 0) { debug = true; }
        var _this = _super.call(this) || this;
        _this.toolsUrl = toolsConfig.toolsUrl;
        return _this;
    }
    /**
     * 获取省份列表
     */
    ToolsClient.prototype.getProvinces = function () {
        return this.get(this.toolsUrl + "/api/address/provinces", {});
    };
    /**
     * 获取城市列表
     * @param provincesId 省份ID
     */
    ToolsClient.prototype.getCities = function (provincesId) {
        return this.get(this.toolsUrl + "/api/address/citys/" + provincesId, {});
    };
    /**
     * 获取区/县列表
     * @param cityId 城市ID
     */
    ToolsClient.prototype.getArea = function (cityId) {
        return this.get(this.toolsUrl + "/api/address/countys/" + cityId, {});
    };
    /**
     * 获取单条省/市/区数据
     * @param id 省市区ID
     */
    ToolsClient.prototype.getAddress = function (id) {
        return this.get(this.toolsUrl + "/api/address/" + id);
    };
    return ToolsClient;
}(base_1.BaseClient));
exports.ToolsClient = ToolsClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9vbHMtY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NsaWVudHMvdG9vbHMtY2xpZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUNBLCtCQUFvQztBQUVwQztJQUFpQywrQkFBVTtJQUd6QyxxQkFDRSxLQUFxQixFQUNyQixXQUVDO1FBSEQsc0JBQUEsRUFBQSxZQUFxQjtRQUR2QixZQU1FLGlCQUFPLFNBRVI7UUFEQyxLQUFJLENBQUMsUUFBUSxHQUFHLFdBQVcsQ0FBQyxRQUFRLENBQUM7O0lBQ3ZDLENBQUM7SUFFRDs7T0FFRztJQUNJLGtDQUFZLEdBQW5CO1FBQ0UsTUFBTSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUksSUFBSSxDQUFDLFFBQVEsMkJBQXdCLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDaEUsQ0FBQztJQUVEOzs7T0FHRztJQUNJLCtCQUFTLEdBQWhCLFVBQWlCLFdBQWdCO1FBQy9CLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFJLElBQUksQ0FBQyxRQUFRLDJCQUFzQixXQUFhLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDM0UsQ0FBQztJQUVEOzs7T0FHRztJQUNJLDZCQUFPLEdBQWQsVUFBZSxNQUFXO1FBQ3hCLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFJLElBQUksQ0FBQyxRQUFRLDZCQUF3QixNQUFRLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDeEUsQ0FBQztJQUVEOzs7T0FHRztJQUNJLGdDQUFVLEdBQWpCLFVBQWtCLEVBQU87UUFDdkIsTUFBTSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUksSUFBSSxDQUFDLFFBQVEscUJBQWdCLEVBQUksQ0FBQyxDQUFDO0lBQ3hELENBQUM7SUFDSCxrQkFBQztBQUFELENBQUMsQUEzQ0QsQ0FBaUMsaUJBQVUsR0EyQzFDO0FBM0NZLGtDQUFXIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/clients/tools-client.js
// module id = 200
// module chunks = 44